import BaseMenu from './BaseMenu';
import BaseUISystem from '../BaseUISystem';
import { UIActions } from '../../../State/UI/UIActions';
import UITextComponent from '../../../Component/UI/Text';
import Game from '../../../Game';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import { applyDefaultButtonAnimation } from '../UIHelper';
import { GameActions } from '../../../State/Game/GameActions';
import { PlayerActions } from '../../../State/Player/PlayerActions';

const BTN_TERMS: string = 'main_container/terms_button';
const BTN_PRIVACY: string = 'main_container/privacy_button';
const BTN_AGREE: string = 'main_container/agree_button';

const URL_TERMS_OF_USE: string = 'https://www.softgames.de/terms-of-use';
const URL_PRIVACY_POLICIES: string = 'https://www.softgames.de/privacy';

export default class GDPRMenuHandler extends BaseMenu {
    constructor(uiSystem: BaseUISystem) {
        super('gdprMenu', uiSystem);
    }

    protected onShow(params: any): void {}

    protected onCreate(): void {
        const btnTerms = this.element.find(BTN_TERMS);
        btnTerms.on(GameObjectEvent.SELECTED, () => {
            Game.sdk.driver.openUrl(URL_TERMS_OF_USE);
        });
        applyDefaultButtonAnimation(btnTerms, AUDIO_UI_BUTTON_DEFAULT);

        const btnPrivacy = this.element.find(BTN_PRIVACY);
        btnPrivacy.on(GameObjectEvent.SELECTED, () => {
            Game.sdk.driver.openUrl(URL_PRIVACY_POLICIES);
        });
        applyDefaultButtonAnimation(btnPrivacy, AUDIO_UI_BUTTON_DEFAULT);

        const btnAgree = this.element.find(BTN_AGREE);
        btnAgree.on(GameObjectEvent.SELECTED, () => {
            Game.state.dispatch(PlayerActions.agreeWithTerms());
            Game.state.dispatch(UIActions.hidePopup(this.name));

            if (Game.state.getState().playerState.FTUE) {
                Game.state.dispatch(
                    GameActions.loadLevel(
                        1,
                        `${Game.config.levelBasePath}/world_1_paris/level_1.json`
                    )
                );
            }
        });
        applyDefaultButtonAnimation(btnAgree, AUDIO_UI_BUTTON_DEFAULT);
    }
}
